import { flexRender, type Row } from '@tanstack/react-table';

import { cn } from '@nesso/ui/lib/utils';
import { TableCell, TableRow } from '@nesso/ui/primitives/table';

import type { SessionListItem } from '@/entities/session';

type Props = {
    row: Row<SessionListItem>;
    hideRowBorder: boolean;
    disabled?: boolean;
    onClick: () => void;
};

export function PastSessionsTableRow({ row, hideRowBorder, disabled = false, onClick }: Props) {
    const session = row.original;

    return (
        <TableRow
            className={cn(
                'grid grid-cols-[minmax(0,1fr)_auto_3.25rem] xs:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_3.25rem] cursor-pointer hover:bg-muted/50 h-[3.25rem] px-6 xs:px-0',
                session.actions.includes('REVIEW_NOTE') && 'font-bold',
                hideRowBorder && 'border-b-0',
                disabled && 'cursor-not-allowed',
            )}
            onClick={onClick}
        >
            {row.getVisibleCells().map((cell) => (
                <TableCell
                    key={cell.id}
                    className={cn(
                        'min-w-0 overflow-hidden !py-2 h-full flex items-center',
                        cell.column.columnDef.meta?.className,
                    )}
                >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
            ))}
        </TableRow>
    );
}
